/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocsAccountSharingInfo {
    getFixupPrototypeFunction() { return AwsSsmDocsAccountSharingInfo.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocsAccountSharingInfo>): AwsSsmDocsAccountSharingInfo {
        let obj = Object.assign(new AwsSsmDocsAccountSharingInfo(), model);
        AwsSsmDocsAccountSharingInfo.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocsAccountSharingInfo>): AwsSsmDocsAccountSharingInfo {
        if (!model) return null;
        return AwsSsmDocsAccountSharingInfo.newInstance(<AwsSsmDocsAccountSharingInfo> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocsAccountSharingInfo) {
        if (!obj) return;

        models.AwsSsmDocsAccountSharingInfo.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocsAccountSharingInfo): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocsAccountSharingInfo.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * The Amazon Web Services account ID where the current document is shared
     */
    account_id: string;

    /**
     * The version of the current document shared with the account.
     */
    shared_document_version: string;

}
